import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "../../../shadcn/components/ui/Card";

export default function FilledLeaseForm() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get `id` from the URL
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch form data
  useEffect(() => {
    const fetchFormData = async () => {
      try {
        const token = localStorage.getItem("authToken");

        if (!token) {
          setError("Authentication token is missing.");
          setLoading(false);
          return;
        }

        const response = await axios.post(
          `https://silver-tlc-backend-delta.vercel.app/api/v1/individual/leaseform/get-specific`,
          {
            token: token,
            formId: id,
          }
        );

        if (response.data && response.data.leaseFormData) {
          setFormData(response.data.leaseFormData);
        } else {
          setError("No form data found.");
        }

        setLoading(false);
      } catch (err) {
        setError("Failed to fetch form data. Please try again.");
        setLoading(false);
      }
    };

    fetchFormData();
  }, [id]);

  const handleBreadcrumbClick = () => {
    navigate("/Dashboard/application");
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  const leftDetails = [
    { label: "Landlord", value: formData.landlord },
    { label: "Landlord Address", value: formData.landlordAddress },
    { label: "Tenant", value: formData.tenant },
    { label: "Tenant Home Address", value: formData.tenantHomeAddress },
    { label: "Tenant Trade Name", value: formData.tenantTradeName },
    { label: "Demised Property", value: formData.demisedProperty },
  ];

  const rightDetails = [
    { label: "Lease Term", value: formData.leaseTerm },
    { label: "Commencement Date", value: formData.commencementDate },
    { label: "Rental for the term shall be:", value: formData.rentalForTerm },
    { label: "Security Deposit for term:", value: formData.securityDeposit },
    { label: "Total due at Commencement:", value: formData.totalAtCommencement },
    { label: "Permitted use:", value: formData.permittedUse },
  ];

  return (
    <div className="p-6">
      {/* Breadcrumbs */}
      <div className="mb-4 text-sm">
        <button
          onClick={handleBreadcrumbClick}
          className="text-gray-500 hover:text-gray-700"
        >
          Applications
        </button>
        <span className="mx-2 text-gray-400">&gt;</span>
        <span className="text-purple-600 font-medium">Lease Application</span>
      </div>
      <h2 className="text-xl font-semibold mb-4">Lease Form</h2>
      <div className="grid md:grid-cols-2 gap-4">
        <Card className="p-4">
          <div className="space-y-4">
            {leftDetails.map((detail, index) => (
              <div
                key={index}
                className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-100 pb-2"
              >
                <span className="text-sm text-gray-600 font-medium">
                  {detail.label}
                </span>
                <span className="text-sm">{detail.value || "N/A"}</span>
              </div>
            ))}
          </div>
        </Card>

        <Card className="p-4">
          <div className="space-y-4">
            {rightDetails.map((detail, index) => (
              <div
                key={index}
                className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-100 pb-2"
              >
                <span className="text-sm text-gray-600 font-medium">
                  {detail.label}
                </span>
                <span className="text-sm">{detail.value || "N/A"}</span>
              </div>
            ))}
          </div>
        </Card>
      </div>
    </div>
  );
}
